// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TextBox from 'common/components/ui/TextBox';
import DevFlag from 'common/components/DevFlag';
import GiveAccessToFolloCheckBox from './GiveAccessToFolloCheckBox';
import Email from '../../../domain/Email';
import RadioCustomer from '../types/RadioCustomer';

export const ADVERTISER_NAME_FIELD_ID = 'advertiserName';
export const EMAIL_FIELD_ID = 'email';
export const FULLNAME_FIELD_ID = 'fullname';

const Row = styled.div`
  justify-content: center;
  padding-top: ${({ theme }) => theme.metrics.largeMargin}px;
`;

interface Props {
  customer: RadioCustomer;
  onInvalidCustomerChange: () => void;
  onValidCustomerChange: (RadioCustomer) => void;

  theme: any;
  t: any;
}

interface State {
  modifiedCustomer: RadioCustomer;
  emailError: boolean
}

export class EditCustomerForm extends React.Component<Props, State> {
  state = {
    modifiedCustomer: this.props.customer,
    emailError: false,
  };

  onEditedCustomerEmail = (value: string) => {
    const newEmail = value;
    const { modifiedCustomer } = this.state;
    const modifiedCustomerWithNewEmail = modifiedCustomer.withEmail(newEmail);
    this.setState({ emailError: false, modifiedCustomer: modifiedCustomerWithNewEmail }, this.onChangeCustomer);
  };

  onEditedCustomerAdvertiserName = (value: string) => {
    const newAdvertiserName = value;
    const { modifiedCustomer } = this.state;
    const modifiedCustomerWithNewAdvertiserName = modifiedCustomer.withAdvertiserName(newAdvertiserName);
    this.setState({ modifiedCustomer: modifiedCustomerWithNewAdvertiserName }, this.onChangeCustomer);
  };

  onEditedCustomerName = (value: string) => {
    const newName = value;
    const { modifiedCustomer } = this.state;
    const modifiedCustomerWithNewName = modifiedCustomer.withName(newName);
    this.setState({ modifiedCustomer: modifiedCustomerWithNewName }, this.onChangeCustomer);
  };

  onGiveAccessToFolloChanged = (giveAccessToFollo: boolean) => {
    const { modifiedCustomer } = this.state;
    const modifiedCustomerWithAccessToFollo = modifiedCustomer.withAccessToFollo(giveAccessToFollo);
    this.setState({ modifiedCustomer: modifiedCustomerWithAccessToFollo }, this.onChangeCustomer);
  };

  onChangeCustomer = () => {
    if (this.customerHasChanged() && this.emailIsValid()) {
      this.props.onValidCustomerChange(this.state.modifiedCustomer);
    } else {
      this.props.onInvalidCustomerChange();
    }
  };

  customerHasChanged = () => {
    return !this.props.customer.isEqual(this.state.modifiedCustomer);
  };

  emailIsValid = () => {
    const email = this.state.modifiedCustomer.getContactEmail();
    return Email.isValid(email);
  };

  checkEmailError = () => {
    const isInvalid = !this.emailIsValid();
    this.setState({ emailError: isInvalid });
  };

  render() {
    const { t, customer } = this.props;

    return (
      <React.Fragment>
        <Row className="row">
          <div className="col-lg-11 col-xs-11">
            <TextBox
              onChange={this.onEditedCustomerAdvertiserName}
              id={ADVERTISER_NAME_FIELD_ID}
              value={this.state.modifiedCustomer.getAdvertiserName()}
              label={t('company')}
            />
          </div>
        </Row>
        <Row className="row">
          <div className="col-lg-11 col-xs-11">
            <TextBox
              onBlur={this.checkEmailError}
              helperText={this.state.emailError ? t('invalidEmailMessage') : undefined}
              error={this.state.emailError}
              onChange={this.onEditedCustomerEmail}
              id={EMAIL_FIELD_ID}
              value={this.state.modifiedCustomer.getContactEmail()}
              label={t('email')}
            />
          </div>
        </Row>
        <Row className="row">
          <div className="col-lg-11 col-xs-11">
            <TextBox
              onChange={this.onEditedCustomerName}
              id={FULLNAME_FIELD_ID}
              value={this.state.modifiedCustomer.getContactFullName()}
              label={t('fullname')}
            />
          </div>
        </Row>
        <DevFlag flag="FOLLO_WITHOUT_FOLLO" >
          <Row className="row">
            <div className="col-lg-11 col-xs-11">
              <GiveAccessToFolloCheckBox
                hasAccessToFollo={customer.hasAccessToFollo}
                giveAccessToFollo={this.state.modifiedCustomer.hasAccessToFollo}
                onGiveAccessToFolloChanged={this.onGiveAccessToFolloChanged}
              />
            </div>
          </Row>
        </DevFlag>
      </React.Fragment>
    );
  }
}


export default translate('customers')(withTheme(EditCustomerForm));



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/EditCustomerForm.js